
import Vue, { PropType } from 'vue';
import Icon from '@/common/icon/Icon.vue';
import Badge from '@/common/badge/Badge.vue';
import { get } from 'lodash';

interface ViewersConfig {
    count: number
}

export default Vue.extend({
    components: {
        Icon,
        Badge
    },

    props: {
        config: {
            type: Object as PropType<ViewersConfig>,
            default: () => ({} as ViewersConfig)
        },
    },

    computed: {
        count(): number {
            return this.config?.count ?? 0;
        }
    }
});
